import { render, staticRenderFns } from "./MarketingCostsList.vue?vue&type=template&id=11b04422"
import script from "./MarketingCostsList.vue?vue&type=script&lang=js"
export * from "./MarketingCostsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b04422')) {
      api.createRecord('11b04422', component.options)
    } else {
      api.reload('11b04422', component.options)
    }
    module.hot.accept("./MarketingCostsList.vue?vue&type=template&id=11b04422", function () {
      api.rerender('11b04422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/FinancialPlan/Components/Expenses/MarketingCost/MarketingCostsList.vue"
export default component.exports